// @flow

import styled, { css } from 'styled-components';
import { media } from '../../../helpers';
import type { Theme } from '../../../types';

export default styled<any, Theme>('div')`
  align-items: flex-start;
  display: flex;
  flex-direction: column;

  ${media.lg(css`
    align-items: center;
    flex-direction: row;
  `)}
`;
